import { TagModel } from '../models/TagModel';
import { normalizeMainMedia } from '../../mainMedia/normalizers/MainMediaNormalizer';
import { normalizeSeo } from '../../seo/normalizers/SeoNormalizer';

export const normalizeTag = (response: any): TagModel => {
    return {
        id: response?.id ? response.id : null,
        createdAt: response?.created_at ? response.created_at : '',
        description: response?.description ? response.description : '',
        entityType: response?.entity_type ? response.entity_type : '',
        mainMedia: response?.main_media ? normalizeMainMedia(response.main_media) : [],
        seo: normalizeSeo(response?.seo ?? null),
        title: response?.title ? response.title : null,
        updatedAt: response?.updated_at ? response.updated_at : null,
        weight: response?.weight ? response.weight : null,
    };
};
